module.exports = __webpack_public_path__ + "img/cu.5d0e09a0.svg";